import type { LegacyIconDefinition } from "./legacyIcons";

type LegacyIconProps = {
  icon: LegacyIconDefinition;
  className?: string;
};

export const LegacyIcon = ({ icon, className = "" }: LegacyIconProps) => (
  <svg
    aria-hidden
    viewBox={`0 0 ${icon.width} ${icon.height}`}
    className={`fill-current ${className}`}
  >
    <path d={icon.path} />
  </svg>
);
